// extracted by mini-css-extract-plugin
module.exports = {"iconLink":"_efe4b5","iconButton":"_89a166"};